import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import axios, { type AxiosError } from 'axios';
import { type ReactNode } from 'react';

const DEFAULT_STALE_TIME = 1000 * 60 * 5;
const DEFAULT_RETRY_COUNT = 2;

const shouldRetry = (failureCount: number, error: AxiosError): boolean => {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError;
    if (
      axiosError.response?.status &&
      axiosError.response.status !== 408 && // Retries on 408 (Request Timeout) errors
      axiosError.response.status >= 400 &&
      axiosError.response.status <= 422
    ) {
      return false;
    }
  }

  return failureCount < DEFAULT_RETRY_COUNT;
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: DEFAULT_STALE_TIME,
      retry: shouldRetry,
    },
  },
});

interface QueryProviderProps {
  children: ReactNode;
}

export function QueryProvider({ children }: QueryProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
}
